<template>
    <div>
       <van-popup v-model ="showPop" position="bottom" >
          <van-form style="margin-top:10px">
            <van-list  
              :finished ="finishedLoading"
              finished-text="没有更多了"
              style="height:400px;overflow: scroll;"
            >
              <van-cell v-for="item in data" :key="item.id" :title="item.name" @click="onItemClick(item)"  :class="item.select?'select':'unselect'">
              </van-cell>
            </van-list>
  
            <van-submit-bar type="info" button-text="确认" @submit="select" v-if="!isSingle">
            </van-submit-bar>
          </van-form>
          
      </van-popup>
    </div>
  </template>
  
  <script>
  import { Tabbar,TabbarItem,Icon,Button,Col,Toast,Dialog,Tab, Tabs} from 'vant';
  export default {
    name: 'SuppliersSelectDialog',
    props:{
      isSingle:false
    },
    components: {
      Toast
    },
    computed: {
    },
    data() {
      return {
          data:[],
          showPop:false,
          searchKey:'',
          finishedLoading:false
      };
    },
    mounted(){
      
    },
    methods: {
      open(data,isNextWorkManshipJumpEnable){
        if(!isNextWorkManshipJumpEnable){
          Toast('未启用工序跳转功能!');
          return;
        }

        var d = JSON.parse(JSON.stringify(data));
        d.forEach(o=>{
          o.id = o.woIndex;
          o.name = '【'+ o.woIndex + '】'+ o.workmanshipName;
        })
        this.showPop = true;
        this.data = d;
      },
      onItemClick(item){
        if(this.isSingle){
          this.$emit('select',[item][0]);
          this.showPop = false;
          return;
        }
  
        item.select = !item.select;
        this.$forceUpdate();
      },
      select(){
        let selectItems = this.data.filter(o=> o.select);
        this.$emit('select',selectItems[0]);
        this.showPop = false;
      }
    }
  };
  </script>
  
  <style lang="less" scoped>
  .select{
    color:dodgerblue
  }
  </style>
  